import { FormLayout, InputField, TextareaField } from '@app/lib/form'
import { Component } from '@contember/interface'
import { LocaleSideDimension } from '../locale-side-dimension'

export const OrganizationForm = Component(() => (
	<FormLayout>
		<LocaleSideDimension>
			<InputField field="name" label="Trade name" inputProps={{ placeholder: 'vshosting~' }} />
			<InputField field="legalName" label="Legal name" inputProps={{ placeholder: 'vshosting s.r.o.' }} />
			<TextareaField field="description" label="Company description" />

			<InputField field="streetAddress" label="Street address" />
			<InputField field="addressLocality" label="City" />
			<InputField field="postalCode" label="Postal code" />
			<InputField field="addressCountry" label="Country code" description="ISO 3166-1 alpha-2, e.g. CZ, DE, HU" inputProps={{ placeholder: 'CZ' }} />

			<InputField field="telephone" label="Phone" inputProps={{ placeholder: '+420 246 035 835' }} />
			<InputField field="email" label="E-mail" inputProps={{ type: 'email' }} />

			<InputField field="vatId" label="VAT ID" inputProps={{ placeholder: 'CZ28786530' }} />
			<InputField field="registrationId" label="Company registration ID" inputProps={{ placeholder: '28786530' }} />
			<InputField field="areaServed" label="Area served" description="Country codes separated by commas, e.g. CZ, SK" />
		</LocaleSideDimension>
	</FormLayout>
))
